import { useEffect, useRef, useState } from "react";
import AsyncSelect from "react-select/async";

import { getStores } from "../../../MyApi/stores";
import SkeletonWrapper from "../skeletonWrapper";

const EnhancedSearchStoreGroup = ({
  setStoreId,
  value,
  setSectionType,
  setPrices,
  setSectionId,
  product,
  setErrors,
  disabled,  
  isMulti,
  type
  
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const timeOutId = useRef(null);
  const [defaultStores, setDefaultStores] = useState([]);

  useEffect(() => {
    if (!value || !defaultStores.length) {
      setSelectedOption(null);
      return;
      
    }

    setSelectedOption(value);
  }, [defaultStores ,value ]);


// const groupStores = (stores = []) => {
//   const groups = {};

//   stores.forEach((store) => {
//     const storeGroups = store.store_group || [];

//     storeGroups.forEach((group) => {
//       const key = store?.name || "Other";

//       if (!groups[key]) {
//         groups[key] = [];
//       }

//       groups[key].push({
//         label: store.name, 
//         value: store.id,
//         name: store.name, 
//         ...store,        
//       });


//     });
//   });

// const formatedData= Object.keys(groups).map((key) => ({
//   label: key,
//   name: key,
//   options: groups[key].flatMap((store) =>
//     (store.store_group || []).map((group) => ({
//       label: group.name,
//       value: group.id,
//       storeId: store.id,
//       ...group,
//     }))
//   ),
// }));
const groupStores = (stores = []) => {
  return stores.map((store) => ({
    label: store.name,
    value: store.id,
    name: store.name,
    options: (store.store_group || []).map((group) => ({
      label: group.name,
      value: group.id,
         storeId: store.id,
         ...group
    })),
  }));
};
  useEffect(() => {
    const fetchDefaultStores = async () => {
      setLoading(true);
      try {   
        const res = await getStores("","","branch");
        setDefaultStores(groupStores(res?.data?.Stores || []));
        console.log('first',  groupStores(res?.data?.Stores || []))
        console.log('res?.data?.Stores', res?.data?.Stores)
      } catch (err) {
        setDefaultStores([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDefaultStores();
  }, []);
  const handelSearch = (selectedOptions) => {
    if (!selectedOptions) {
      setStoreId("");
      setSelectedOption(null);
      return;
    }
    setSelectedOption(selectedOptions);
    const storeId = selectedOptions ? selectedOptions.id : "";
    const storedName =selectedOptions ?selectedOptions.name:""
    if (isMulti) {
      setStoreId(selectedOptions);
    } else {
      setStoreId(storeId , storedName);
    }
    console.log(selectedOptions.section_type, "sectionType");

    if (product) {
      setSectionId(selectedOptions.section_id);
      setSectionType(selectedOptions.section_type);
      setPrices((prev) => ({
        ...prev,
        currency_factor: +selectedOptions.currency_factor,
      }));
    }
  };
  const enhancedSearchStores = (value) => {
    return new Promise((resolve) => {
      if (value.length >= 5) {
        clearTimeout(timeOutId.current);
        timeOutId.current = setTimeout(async () => {
          try {
            let res = await getStores("", { search: value } ,type);
            resolve(groupStores(res.data.Stores || [] ));
          } catch (error) {
            resolve([]);
          }
        }, 500);
      } else {
        resolve([]);
      }
    });
  };
  return (
    <SkeletonWrapper isLoading={isLoading}>
      <AsyncSelect
        getOptionValue={(e) => e.id}
        getOptionLabel={(e) => e.name}
        loadOptions={enhancedSearchStores}
        value={selectedOption}
        onChange={handelSearch}
        defaultOptions={defaultStores}
        placeholder="اختار المتجر"
        isClearable
        isDisabled={disabled || isLoading}
        isLoading={isLoading}
        isMulti={isMulti}
      />
    </SkeletonWrapper>
  );
};

export default EnhancedSearchStoreGroup;
